import React from 'react';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useEffect } from 'react';

export default function RecapLaunch({ launch, conf }) {
    return (
        <Box>
            <ul>
                <Typography variant='body2' color='textSecondary' sx={{ marginBottom: '1em' }}>
                    <Typography key='1' component='li' variant='body2' color='textSecondary'>

                        <b>Project</b>: {launch.selectedProject}
                    </Typography>
                    {launch.tag && (
                        <Typography key='flow' component='li' variant='body2' color='textSecondary'>
                            <b>Process</b>: {launch.tag}
                        </Typography>
                    )}
                    {!conf.skip_uploadDataStep && (
                        <Typography key='dataset' component='li' variant='body2' color='textSecondary' sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                            <b>Dataset</b>: {launch.filename}
                        </Typography>)
                    }
                    {launch.steps.filter(el => el.label === 'Additional data file').length > 0 && conf.selectedAdditionalData.map((file, id) => (
                        <Typography key={'additional file' + id} component='li' variant='body2' color='textSecondary'>
                            <b>{file.folder}</b>: {file.value}
                        </Typography>
                    ))}
                    {launch.steps.filter(el => el.label === 'Static Pages').length > 0 && conf.selectedCovers.map((cover, id) => (
                        <Typography key={'Static pages' + id} component='li' variant='body2' color='textSecondary'>
                            <b>{cover.folder}</b>: {cover.multiple && Array.isArray(cover.tagsValues) ? cover.tagsValues.join(', ') : cover.tagsValues}
                        </Typography>
                    ))}
                    {launch.steps.filter(el => el.label === 'Visuals').length > 0 && conf.selectedAssets.map((file, id) => (
                        <Typography key={'file' + id} component='li' variant='body2' color='textSecondary'>
                            <b>{file.displayName ? file.displayName : file.folder}</b>: {file.value}
                        </Typography>
                    ))}
                    {launch.steps.filter(el => el.label === 'Options').length > 0 && conf.selectedPaginationOptions.map((opt, id) => {
                        if (opt.component === 'form-list') {
                            if (opt.visibleCalc !== false)
                                return (
                                    <Typography key={'options' + id} component='li' variant='body2' color='textSecondary'>
                                        <b>{opt.nome}</b>: {opt.list.map(block => block.map(single => single.visibleCalc === false ? '' : `${single.nome}: ${single.value}`).join(', ')).join(' - ')}
                                    </Typography>
                                )
                        }
                        else if (opt.component === 'checkBox-list') {
                            return (
                                <Typography key={'options' + id} component='li' variant='body2' color='textSecondary'>
                                    <b>{opt.nome}</b>: {opt.list.map(block => `${block.name}: ${block.value === true ? "Active" : "Non Active"}`).join(' - ')}
                                </Typography>
                            )
                        }
                        else if (opt.component === 'coordinatesAutocomplete') {
                            if (opt.visibleCalc !== false)
                                return (
                                    <Typography key={'options' + id} component='li' variant='body2' color='textSecondary'>
                                        <b>{opt.nome}</b>: {opt.value.location} ({opt.value.lat} | {opt.value.long})
                                    </Typography>
                                )
                        }
                        else if (opt.component === 'DatePickerCustomizable') {
                            if (opt.visibleCalc !== false)
                                return (
                                    <Typography key={'options' + id} component='li' variant='body2' color='textSecondary'>
                                        <b>{opt.nome}</b>: {opt.value ? `${opt.views.includes("year") ? opt.value.years : ""} ${opt.views.includes("month") ? opt.value.months : ""} ${opt.views.includes("day") ? opt.value.date : ""}` : ""}
                                    </Typography>
                                )
                        }
                        else if (opt.component === "autocompleteMultival") {
                            if (opt.visibleCalc !== false)
                                return (
                                    <Typography key={'options' + id} component='li' variant='body2' color='textSecondary'>
                                        <b>{opt.nome}</b>: {opt.value ? `${opt.value.map(v => v = v.name).join(', ')}` : ''}
                                    </Typography>
                                )
                        }
                        else {
                            if (opt.visibleCalc !== false)
                                return (
                                    <Typography key={'options' + id} component='li' variant='body2' color='textSecondary'>
                                        <b>{opt.nome}</b>: {opt.value !== undefined ? `${opt.value}` : `${opt.default}`}
                                    </Typography>
                                )
                        }
                    }
                    )}


                    {launch.steps.filter(el => el.label === 'Integrations').length > 0 &&
                        conf.integrationsOptions && Object.entries(conf.integrationsOptions).map(([groupKey, options]) => (
                            <React.Fragment key={`integration-group-${groupKey}`}>
                                <Typography component='li' variant='body2' color='textSecondary' sx={{ fontWeight: 600, marginTop: '0.5em' }}>
                                    {groupKey}
                                </Typography>
                                {options.map((opt, idx) => {
                                    if (opt.component === 'PlytixProductList') {
                                        return (
                                            <Typography key={`integration-${groupKey}-${idx}`} component='li' variant='body2' color='textSecondary' sx={{ marginLeft: '1.5em' }}>
                                                <b>{opt.nome}</b>: {opt.value ? opt.value.name : '-'}
                                            </Typography>
                                        )
                                    }
                                    else if (['AkeneoChannelPicker', 'AkeneoLocalePicker', 'AkeneoFamilyPicker'].includes(opt.component)) {
                                        const display = Array.isArray(opt.value) && opt.value.length > 0
                                            ? opt.value.map(v => v.code).join(', ')
                                            : (opt.value ? (opt.value.code || '-') : '-');
                                        return (
                                            <Typography key={`integration-${groupKey}-${idx}`} component='li' variant='body2' color='textSecondary' sx={{ marginLeft: '1.5em' }}>
                                                <b>{opt.nome}</b>: {display}
                                            </Typography>
                                        )
                                    }
                                    else if (opt.component === 'Checkbok') {
                                        return (
                                            <Typography key={`integration-${groupKey}-${idx}`} component='li' variant='body2' color='textSecondary' sx={{ marginLeft: '1.5em' }}>
                                                <b>{opt.nome}</b>: {opt.value === true ? "Active" : "Non Active"}
                                            </Typography>
                                        )
                                    }
                                    else {
                                        return (
                                            <Typography key={`integration-${groupKey}-${idx}`} component='li' variant='body2' color='textSecondary' sx={{ marginLeft: '1.5em' }}>
                                                <b>{opt.nome}</b>: {opt.value !== undefined && opt.value !== null ? `${opt.value}` : '-'}
                                            </Typography>
                                        )
                                    }
                                })}
                            </React.Fragment>
                        ))
                    }

                    {conf.internalTest && (
                        <Typography key='only-admin' component='li' variant='body2' color='red'>
                            <b>internal test</b>: yes
                        </Typography>
                    )}
                    {conf.doOnlyValidation && (
                        <Typography key='only-validation' component='li' variant='body2' color='blue'>
                            <b>data integration only</b>: yes
                        </Typography>
                    )}


                </Typography>
            </ul>




            {!conf.skip_uploadDataStep && launch.filename.length > 50 &&
                <Box width={'100%'}>
                    <Alert elevation={0} severity="warning" sx={{ marginTop: '1em', display: 'inline-flex' }}>Datafile's original name will be truncated at 50 characters for exported files.</Alert>
                </Box>
            }
            {(conf.assetFolder.length > 0 || conf.indesignFolder.length > 0 || conf.additionalDataFolder.length > 0) &&
                <Box width={'100%'}>
                    <Alert elevation={0} severity="info" sx={{ marginTop: '1em', display: 'inline-flex' }}>Remember to upload all assets before launch!</Alert>
                </Box>
            }
            {conf.queue === 'requests_vpc_test' && (
                <Box width={'100%'}>
                    <Alert elevation={0} severity="warning" sx={{ marginTop: '1em', display: 'inline-flex' }}>
                        This process will run in a test enviroment! The conf set up the queue "requests_vpc_test".<br></br>
                        indesign_version: {conf.indesign_version}
                    </Alert>
                </Box>)
            }



        </Box>

    )
}